import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Checkbox,
    Select
} from '@shopify/polaris';

export function UpdateProductMetafieldFromTagGroupRuleSettings(props) {

    const handleTagGroupPrefixChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagGroupPrefix = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldNamespaceAndKeyChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKey = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldTypeChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldType = value;
        props.onSettingsChange(newSettings);
    }

    const onRemoveMetafieldValueWhenTagIsMissingChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeMetafieldValueWhenTagIsMissing = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Tag Group prefix"
                        placeholder="Tag Group prefix"
                        helpText={
                            <span>
                                Text that specifies the prefix of the respective tag group. If you would like to work with tags starting with "Category_", please input that value.
                            </span>
                        }
                        value={props.settings.tagGroupPrefix}
                        error={props.settingsErrors["tagGroupPrefix"]}
                        onChange={handleTagGroupPrefixChange}
                        autoComplete="off"
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Metafield Namespace and key"
                        placeholder="Namespace and key. For example mystore.custom_size"
                        helpText={
                            <span>
                                The namespace and key as they appear in your admin.
                            </span>
                        }
                        value={props.settings.metafieldNamespaceAndKey}
                        error={props.settingsErrors["metafieldNamespaceAndKey"]}
                        onChange={handleMetafieldNamespaceAndKeyChange}
                        autoComplete="off"
                    />
                    <Select
                        label="Metafield Type"
                        options={[
                            {
                                'label': 'Single line text',
                                'value': 'single_line_text_field'
                            },
                            {
                                'label': 'Multi line text',
                                'value': 'multi_line_text_field'
                            }
                        ]}
                        onChange={handleMetafieldTypeChange}
                        value={props.settings.metafieldType}
                        helpText={
                            <span>
                                The type of the metafield that will be populated.
                            </span>
                        }
                    />
                    <Checkbox
                        label="Remove metafield value when no tag group tag is found"
                        helpText={
                            <span>
                                The rule will remove the metafield value (if set) when no tag belonging to the specified tag group is found.
                            </span>
                        }
                        checked={props.settings.removeMetafieldValueWhenTagIsMissing}
                        onChange={onRemoveMetafieldValueWhenTagIsMissingChange}
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}